import type {ICashierPaymentsApi, ICashierPaymentsProps} from '@wix/cashier-payments-widget'
import {CashierPaymentsWidgetLazy} from '@wix/cashier-payments-widget/lazy'
import {focusElement, hookToAttributeSelector, parseQueryParams} from '@wix/panda-js-utils'
import {EVENTS_APP_ID, getBuyerTotal} from '@wix/wix-events-commons-statics'
import React from 'react'
import {ReservationState} from '../../../../../../../commons/enums'
import {Interaction} from '../../../../services/logger'
import {PaymentWidgetProps} from './interfaces'

const PAYMENT_WIDGET_ID = 'payment-widget'

export class PaymentWidget extends React.Component<PaymentWidgetProps> {
  cashierApi: ICashierPaymentsApi

  componentDidMount() {
    this.focus()
  }

  focus = () => focusElement({selector: `#${PAYMENT_WIDGET_ID}`})

  pay = () => this.cashierApi.pay()

  validate = () => this.cashierApi.validate().then(({isValid}) => isValid)

  collapse = () => this.cashierApi.collapse()

  expand = () => this.cashierApi.expand()

  onPaymentMethodChanged = (selectedPaymentMethodId: string) => {
    const {openCantCompletePaymentModal, isPreview, onPaymentMethodChanged} = this.props
    onPaymentMethodChanged(selectedPaymentMethodId)
    if (isPreview) {
      openCantCompletePaymentModal()
    }
  }

  onPaymentResult = (result: any) => {
    if (result.status === 'OK') {
      const {reservationId, eventId, order, navigateToOrder, navigateToOrderUrl} = this.props
      const {request, file} = parseQueryParams(this.props.order.ticketsPdf) || {}
      const token = request ?? file

      if (result?.redirectUrl) {
        navigateToOrderUrl(result.redirectUrl)
      } else {
        navigateToOrder({
          reservationId,
          reservationState: ReservationState.SUCCESS,
          queryParams: {
            token,
            eventId,
            orderNumber: order.orderNumber,
          },
        })
      }
    } else {
      focusElement({selector: hookToAttributeSelector('pw-payment-error')})
    }
  }

  onApiInit = api => {
    this.cashierApi = api
    this.props.updateLayout()
  }

  onFullLoad = () => {
    this.props.logger.finishInteraction(Interaction.PaymentWidgetLoad)
  }

  getCashierProps = (): ICashierPaymentsProps => {
    const {
      snapshotId,
      locale,
      isMobile,
      externalSubmitButton,
      isSite,
      visitorId,
      instanceId,
      msid,
      primaryLanguage,
      siteOwnerId,
      isPreview,
      instance,
      siteStyles,
      isSignedInUser,
      lang,
      order,
    } = this.props
    return {
      configuration: {
        appId: EVENTS_APP_ID,
        msid,
        appInstanceId: instanceId,
        snapshotId,
        locale,
        visitorId,
        isPrimaryLanguage: primaryLanguage,
        siteOwnerId,
        lang,
        viewMode: isPreview ? 'Preview' : 'Site',
        appInstance: instance,
        isSignedInUser,
        amount: getBuyerTotal(order.totalPrice, order.giftCardPaymentDetails).amount,
        currency: order?.totalPrice?.currency,
      },
      siteStyles,
      theme: 'accordion',
      deviceType: isMobile ? 'mobile' : 'desktop',
      externalSubmitButton: externalSubmitButton || !isSite,
      paymentMethodChanged: this.onPaymentMethodChanged,
      paymentResult: this.onPaymentResult,
      onApiInit: this.onApiInit,
      walletPaymentInNewTab: false,
      shouldApplySiteStyles: true,
      allowManualPayment: true,
      isSaveCCEnabled: true,
      onFullLoad: this.onFullLoad,
    }
  }

  render() {
    return (
      <div id={PAYMENT_WIDGET_ID}>
        <CashierPaymentsWidgetLazy {...this.getCashierProps()} />
      </div>
    )
  }
}
